import { render, staticRenderFns } from "./basic-user-img.vue?vue&type=template&id=41226381&scoped=true"
import script from "./basic-user-img.vue?vue&type=script&lang=js"
export * from "./basic-user-img.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41226381",
  null
  
)

export default component.exports